import axiosClient from "../../common"
import constants, { HTTP_METHODS } from '../../../settings/shared/constants'

const _service = (options) => {
    options.baseURL = constants.storageApi.base.url
    
    const jwtToken = localStorage.getItem('accessToken');
    const profile = JSON.parse(localStorage.getItem('profile') || '{}');
    const apiToken = profile?.apiToken;

    // Ensure headers object exists and merge properly
    options.headers = {
        ...(options.headers || {}),
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwtToken}`,
        "api-token": apiToken
    };

    return axiosClient(options)
}

const _constructHeader = (storageId, rootFolder) => {
    let headerObj = {};
    if (storageId !== null && storageId !== undefined) {
        headerObj = {
            "storage-id": storageId,
            "root-folder": (rootFolder === null || rootFolder === undefined) ? '' : rootFolder
        }
    }
    return headerObj
}

const Storage = {
    getBucketsList: (provisionerName, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.buckets.getBuckets,
            method: 'POST',
            data: {},
            headers: {
                "provisioner-id": provisionerName
            },
            onError: onErrorCallBack
        })
    },
    getCORS: (storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.buckets.getCORS,
            method: 'GET',
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },

    configureCORS: (storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.buckets.configureCORS,
            method: HTTP_METHODS.POST,
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    listObjects: (prefix, storageId, rootFolder, pageToken, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.objects.listObjects,
            method: HTTP_METHODS.POST,
            data: {
                prefix: prefix,
                // page_token: pageToken
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    listObjectFilter: (prefix, objFilter, storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.objects.listObjects,
            method: HTTP_METHODS.POST,
            data: {
                prefix: prefix,
                obj_filter: objFilter
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    downloadAppObjectUrl: (objectName, storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.objects.downloadApp,
            method: HTTP_METHODS.POST,
            data: {
                object_name: objectName
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    downloadVersionObjectUrl: (objectName, versionName, storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.objects.downloadVersionApp,
            method: HTTP_METHODS.POST,
            data: {
                object_name: objectName,
                version: versionName
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    uploadObjectUrl: (uploadType, objectName, storageId, rootFolder, onErrorCallBack) => {
        let url = uploadType === "app" ? constants.storageApi.objects.uploadApp : constants.storageApi.objects.uploadObjects
    return _service({
            url: url,
            method: HTTP_METHODS.PUT,
            data: {
                object_name: objectName
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    appVersionList: (objectName, storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.objects.versionList,
            method: HTTP_METHODS.POST,
            data: {
                prefix: objectName
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    createPrefix: (name, storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.prefixs.createPrefix,
            method: HTTP_METHODS.PUT,
            data: {
                prefix_name: name
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    deletePrefix: (name, storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.prefixs.deletePrefix,
            method: HTTP_METHODS.DELETE,
            data: {
                prefix_name: name
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    trashObject: (objectName, storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.objects.trashObject,
            method: 'POST',
            data: {
                prefix: objectName,
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    downloadObjectUrl: (objectName, storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.objects.downloadObject,
            method: 'POST',
            data: {
                object_name: objectName
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    uploadObjectExtractUrl: (objectName, storageId, rootFolder, onErrorCallBack) => {
        let url = constants.storageApi.objects.uploadExtract
    return _service({
            url: url,
            method: HTTP_METHODS.PUT,
            data: {
                object_name: objectName
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    },
    downloadExtractObjectUrl: (objectName, storageId, rootFolder, onErrorCallBack) => {
        return _service({
            url: constants.storageApi.objects.downloadExtract,
            method: HTTP_METHODS.POST,
            data: {
                object_name: objectName
            },
            headers: _constructHeader(storageId, rootFolder),
            onError: onErrorCallBack
        })
    }
}

export default Storage;